'use client'

import { clsx } from 'clsx'

export const BluredBubble = ({
  size,
  className,
  blur = 21,
}: {
  size: number | { width: number; height: number }
  blur?: number
  className?: string
}) => {
  return (
    <div
      className={clsx(
        'pointer-events-none rounded-full bg-dark-control-base',
        className
      )}
      style={{
        width: typeof size === 'number' ? size : size.width,
        height: typeof size === 'number' ? size : size.height,
        filter: `blur(${blur}px)`,
      }}
    />
  )
}
